module.exports = __webpack_public_path__ + "static/media/calendar-icon.d2e35ad5.svg";